import { useAuthStore } from '@quadralize/utils'
import { Navigate, useLocation } from 'react-router-dom'
import { RouteLoader } from '../route-loader/route-loader'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps): React.JSX.Element {
  const location = useLocation()
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return <RouteLoader />
  }

  if (!isAuthenticated) {
    const returnUrl = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/entrar?returnUrl=${returnUrl}`} replace />
  }

  return <>{children}</>
}
